(function($)
{
    $.extend(true, orion, {
        api: {
            productDownloads: {}
        }
    });

    var
        api = orion.api.productDownloads,
        uri = '/v1-api-product-downloads/';

    function read(productNumber)
    {
        var promise = $.ajax(uri, {
            data: { productNumber: productNumber },
            'method': 'GET'
        });

        return promise;
    }

    function prepareDownload(data)
    {
        var promise = $.ajax(uri, {
            data: JSON.stringify(data),
            'method': 'POST'
        });

        return promise;
    }

    api.read = read;
    api.prepareDownload = prepareDownload;
})(jQuery);
